import { combineReducers } from 'redux';
import tablesReducer from './tables';

export default combineReducers({
  tables: tablesReducer,
});
